var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "167.1 265.3 458.4 81.1",
    style: {
      enableBackground: "new 0 0 792 612"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#007DB1;}\r\n\t.st1{fill:#00355F;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M174.8,277.1v66.8h-7.7v-66.8H174.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.3,
    y: 265.3,
    className: "st0",
    width: 135.2,
    height: 11.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M519.8,332.8c-6.5,0-10.1-7.1-10.1-16.6c0-8.3,2.8-16.7,10.2-16.7c7,0,9.8,8.4,9.8,16.6 c0,10-3.8,16.7-9.8,16.7H519.8z M519.7,345.2c13.2,0,26.1-9.3,26.1-29.5c0-16.8-10.2-28.5-25.3-28.5c-16,0-26.6,11.4-26.6,29.4 c0,17.9,11.2,28.6,25.7,28.6H519.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M470.7,287.2c-3.7,0-6.7,1-9.4,2.7c-2.4,1.6-4.6,3.9-6.5,6.8c-2.9-6.5-8-9.5-14.1-9.5c-3.7,0-6.7,1-9.4,2.7 c-2.4,1.6-4.6,3.9-6.5,6.8c-2.9-6.5-8-9.5-14.1-9.5c-3.7,0-6.7,1-9.4,2.7c-2.4,1.6-4.6,3.9-6.5,6.8h-0.2 c-2.1-5.8-7.1-9.5-13.6-9.5c-8.4,0-12.9,5.2-15,8.8h-0.3l-1.2-7.6h-12.1v55.4h15v-32.2c0-1.5,0.1-3.1,0.6-4.4 c0.9-2.7,3.2-6.1,7.2-6.1c5,0,7.2,4.8,7.2,11.7v31.1h15v-32.4c0-1.4,0.2-3.1,0.5-4.3c1.1-3.3,3.6-6,7.2-6c5,0,7.3,4.7,7.3,12.7 v30h15v-32.4c0-1.4,0.2-3.1,0.5-4.3c1.1-3.3,3.6-6,7.2-6c5,0,7.3,4.7,7.3,12.7v30h15v-32.4c0-1.4,0.2-3.1,0.5-4.3 c1.1-3.3,3.5-6,7.2-6c5,0,7.3,4.7,7.3,12.7v30h15v-32.6C487.5,294.7,480.3,287.2,470.7,287.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M319,332.8c-6.5,0-10.1-7.1-10.1-16.6c0-8.3,2.8-16.7,10.2-16.7c7,0,9.8,8.4,9.8,16.6 c0,10-3.8,16.7-9.8,16.7H319z M318.9,345.2c13.2,0,26.1-9.3,26.1-29.5c0-16.8-10.2-28.5-25.3-28.5c-16,0-26.6,11.4-26.6,29.4 C293.1,334.5,304.3,345.2,318.9,345.2L318.9,345.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M270.3,330.5c-4.5,0-8.3-2-11.2-5.9c-2.9-3.9-4.2-8.1-4.3-14.1c0.1-6,1.6-10.8,4.5-14.7 c2.9-3.9,6.7-5.9,11.2-5.9c7.1,0,11.5,3.2,13.3,4.5l6-12c-2-1.6-9.5-6.6-20-6.6c-8.8,0-16.1,3.4-21.8,10.1 c-5.5,6.6-8.4,14.9-8.4,24.6l0,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0,9.7,2.9,18,8.4,24.6c5.6,6.7,13,10.1,21.8,10.1 c12.5,0,20.6-7.1,20.6-7.1l-6.2-12.5C284.3,325.6,277.9,330.5,270.3,330.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M211.5,287.2c4.6,0,18.6,1.1,18.6,23.5v33.3h-7.8v-32.1c0-10.8-3.1-17.9-12.6-17.5 c-10.6,0.4-13.8,10.4-13.8,16.7v32.9H188v-55.4h6.4l1,6.8C195.4,295.3,199.6,287.2,211.5,287.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M552.4,288.5h12.5l1.2,7.6h0.3c2-3.6,7-8.9,15.3-8.9c10.1,0,17.8,7.6,17.8,23.9v32.8h-15.4v-30.7 c0-7.1-2.2-12-7.8-12c-4.3,0-6.8,3.3-7.9,6.5c-0.4,1.1-0.5,2.7-0.5,4.3v32h-15.4V288.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M617.3,329.7c4.5,0,8.2,3.6,8.2,8.3c0,4.8-3.7,8.4-8.2,8.4c-4.5,0-8.2-3.6-8.2-8.4 C609.1,333.3,612.8,329.7,617.3,329.7z M617.3,345.2c3.8,0,6.7-3.1,6.7-7.2c0-4-2.9-7.1-6.7-7.1c-3.8,0-6.8,3.1-6.8,7.1 C610.6,342.1,613.5,345.2,617.3,345.2z M614.1,333.1h3.7c2.3,0,3.3,0.9,3.3,2.8c0,1.8-1.1,2.5-2.5,2.7l2.7,4.3h-1.6l-2.6-4.2 h-1.6v4.2h-1.5V333.1z M615.6,337.5h1.6c1.3,0,2.5-0.1,2.5-1.6c0-1.3-1.1-1.5-2.1-1.5h-2V337.5z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogo);
export default __webpack_public_path__ + "static/media/IC-logo.8639d25096180937e3c628600727f3ac.svg";
export { ForwardRef as ReactComponent };